// const API_URL = 'https://api.u4u.app'
const API_URL = 'https://u4u-api-dev.navintaatech.com'
export default API_URL
